import { useTranslation } from 'react-i18next';
import { ButtonLink } from '@hero/web-components';
import { route } from '@hero/web-hooks';
import RegistrationBox from '@/components/features/Auth/RegistrationBox';

export default function RegisterSuccess() {
  const { t } = useTranslation(['registration']);

  return (
    <RegistrationBox
      img={'/images/verified-success.svg'}
      title={t('verified.title')}
      desc={t('verified.subTitle')}>
      <ButtonLink
        to={route('dashboard')}
        className="w-full mt-8 h-13 rounded-[32px] text-[16px] leading-[26px] font-[500]">
        {t('registration:verified.verifiedBtn')}
      </ButtonLink>
    </RegistrationBox>
  );
}
